import React, { useContext, useEffect, useState } from "react";
import {
  Link,
  NavLink,
  ScrollRestoration,
  useNavigate,
} from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthProvider";
import { ImMobile } from "react-icons/im";
import { FiChevronDown } from "react-icons/fi";

const Navbar = () => {
  const { user, logOut } = useContext(AuthContext);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  let activeStyle = {
    borderRadius: "10px",
    fontWeight: "900",
    backgroundColor: "#0891b2",
    boxShadow: "0px 10px 10px rgba(38, 38, 38, 0.2)",
  };

  useEffect(() => {
    fetch("https://recycle-hut-server.vercel.app/categories")
      .then((res) => res.json())
      .then((data) => setCategories(data));
  }, []);

  const handlelogOut = () => {
    logOut()
      .then(() => {
        navigate("/login");
      })
      .catch((err) => console.error(err));
  };

  const menuItems = (
    <React.Fragment>
      <li className="hover:font-bold hover:text-[16px] font-semibol">
        <NavLink
          to="/home"
          className="rounded-lg hover:shadow-"
          style={({ isActive }) => (isActive ? activeStyle : undefined)}
        >
          <ScrollRestoration />
          Home
        </NavLink>
      </li>

      <li className="hover:font-bold hover:text-[16px] font-semibol">
        <Link className="rounded-lg">
          Categories
          <FiChevronDown className="fill-current ml-[-5px] mr-[-6px]" />
        </Link>
        <ul className="p-3 bg-cyan-600 rounded-md w-40 lg:w-44">
          {categories.map((category) => (
            <li key={category._id}>
              <Link to={`/category/${category._id}`} className="rounded-lg">
                {category.name}
              </Link>
            </li>
          ))}
        </ul>
      </li>

      <li className="hover:font-bold hover:text-[16px] font-semibol">
        <NavLink
          to="/blogs"
          className="rounded-lg hover:shadow-"
          style={({ isActive }) => (isActive ? activeStyle : undefined)}
        >
          Blogs
        </NavLink>
      </li>

      <li className="hover:font-bold hover:text-[16px] font-semibol">
        <NavLink
          to="/dashboard"
          className="rounded-lg hover:shadow-"
          style={({ isActive }) => (isActive ? activeStyle : undefined)}
        >
          Dashboard
        </NavLink>
      </li>

      {user?.uid ? (
        <>
          <li className="font-bold hover:font-extrabold hover:text-[16px] hover:text-warning">
            <button onClick={handlelogOut} className="rounded-lg">
              Log Out
            </button>
          </li>
        </>
      ) : (
        <>
          <li className="font-bold hover:font-extrabold hover:text-[16px]">
            <NavLink
              to="/login"
              className="rounded-lg hover:shadow-"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              Log In
            </NavLink>
          </li>
        </>
      )}
    </React.Fragment>
  );

  return (
    <div className="z-10">
      <div className="navbar flex justify-between bg-cyan-600 text-white">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-[24px] w-[24px] mr-4 ml-2 cursor-pointer"
                viewBox="0 0 448 512"
              >
                <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32" />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-3 ml-[8px] shado rounded-b-lg w-[165px] bg-cyan-600"
            >
              {menuItems}
            </ul>
          </div>

          <Link
            to="/"
            className="btn btn-ghost normal-case ml-[-12px] md:ml-[0px] text-[22px] lg:text-xl hover:font-bold"
          >
            <div className="flex justify-center items-center">
              <span>
                <ImMobile className="text-[25px cursor-pointer mr-[1px] -ml-4 mb-[0px] w-10 h-10 rounded-full p-2" />
              </span>
              <span className="md:mb-[3px] mr-[-4px]">Recycle Hut</span>
            </div>
          </Link>
        </div>

        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal z-10">{menuItems}</ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
